import React from "react";
import Social from "./component/TrudatSocial";
import ReadLaterIcon from "../../ReadLater";
import Link from "../../Link";

export default class TrudatTetragon extends React.Component {
  render() {
    var s = this.props.settings,
      bi = s["background-image"] ? s["background-image"] : "",
      thumbnailSize = "557,375,1,0",
      boxSize = this.props.settings.box_size
        ? this.props.settings.box_size
        : "",
      classes = this.props.classes + " hp__box__tetragon-background " + boxSize;

    bi = window.MEDIA_DOMAIN + "/" + bi.replace(".", "," + thumbnailSize + ".");

    return (
      <Link
        to={s.link}
        {...this.props.events}
        className={classes}
        style={{ backgroundImage: `url("${bi}")` }}
      >
        <ReadLaterIcon link={s.link} image={bi} title={s.title_normal} />
        {s.title_top ? (
          <div className="hp__box__tetragon-top"> {s.title_top} </div>
        ) : (
          <div className="hp__box__tetragon-top" style={{ opacity: "0" }}>
            {" "}
          </div>
        )}

        <div className="hp__box__tetragon-title hp__box__title">
          {s.title_normal ? s.title_normal : "Tytuł"}
        </div>

        <Social stats={s.stats} reactionsColor={s.reactions_color} />

        <div className="hp__box__tetragon-gradient"> </div>
      </Link>
    );
  }
}
